export default Object.freeze({
  Entity: 'entity',
  List: 'list',
  Process: 'process',
  System: 'system',
  Error: 'error',
  Chat: 'chat',
});
